import { useContext, useEffect } from 'react'
import {Routes, Route} from 'react-router-dom'
import {DataContext} from './context/DataContext'
import {useNavigate } from 'react-router-dom';
import { toast } from "sonner";
import {ToastProvider} from './context/ToastContext.jsx'

//PAGES
import Login from './components/Login'
import SelectCompany from './components/SelectCompany'
import LayoutDashboard from './components/LayoutDashboard'
import EmitirComprobantes from './components/pages/Ventas/factura/EmitirComprobantes.jsx'
import VerComprobantes from './components/pages/Ventas/factura/VerComprobantes.jsx'
import Almacen from './components/pages/Archivos/Almacen.jsx'
import AreaLocal from './components/pages/Archivos/AreaLocal.jsx'
import Marca from './components/pages/Archivos/Marca.jsx'
import Medida from './components/pages/Archivos/Medida.jsx'
import TPagos from './components/pages/Archivos/TPagos.jsx'
import Vehiculo from './components/pages/Archivos/Vehiculo.jsx'
import CrearProducto from './components/pages/Productos/CrearProducto.jsx'
import VerProducto from './components/pages/Productos/VerProducto.jsx'
import Categoria from './components/pages/Productos/Categoria.jsx'
import NuevoCliente from './components/pages/Clientes/NuevoCliente.jsx'
import VerCliente from './components/pages/Clientes/VerCliente.jsx'
import EmitirCotizacion from "./components/pages/Ventas/cotizacion/EmitirCotizacion.jsx";
import VerCotizacion from "./components/pages/Ventas/cotizacion/VerCotizacion.jsx";
import EmitirOC from "./components/pages/Compras/EmitirOC.jsx";
import VerOC from "./components/pages/Compras/VerOC.jsx";
import SettingsEmpresa from "./components/pages/Configuracion/SettingsEmpresa.jsx";
import SettingsUsuario from "./components/pages/Configuracion/SettingsUsuario.jsx"
import Series from "./components/pages/Archivos/Series.jsx";
import Conductores from './components/pages/Archivos/Conductores.jsx'
import Reports from './components/pages/Reportes/reports.jsx'

//COMPONENTES FUERA DE LOS NODOS
import Home from './components/pages/Home.jsx'
import SignalGPT from "./components/pages/signalgpt.jsx";
import ViewSale from "./components/pages/Additional/ViewSale.jsx";
import EditPrice from "./components/pages/Additional/EditPrice.jsx";
import EditBuy from "./components/pages/Additional/EditBuy.jsx";
import NuevaES from "./components/pages/Inventario/NuevaEs.jsx";
import VerES from "./components/pages/Inventario/VerES.jsx";
import EditInventary from "./components/pages/Additional/EditInventory.jsx";
import NewNote from "./components/pages/Additional/NewNote.jsx";
import ImportClientes from "./components/pages/Additional/ImportClientes.jsx";
import ImportProductos from "./components/pages/Additional/ImportProductos.jsx";

export default function App() {
  const {saveUser,saveEmpresa} = useContext(DataContext)
  const navigate = useNavigate();
  
  useEffect(() => {
    const checkSession = async () => {
      const obj = localStorage.getItem("session");
      if (obj) {
        const session = JSON.parse(obj);
        const estadoToken = await saveUser(session.idUsuario, session.token);
        if (estadoToken) {
          const empresa = localStorage.getItem("empresa");
          if (empresa) {
            const idEmpresa = JSON.parse(empresa).value;
            saveEmpresa(idEmpresa, session.token);
            navigate('main', { replace: true });
          } else {
            navigate('SelectCompany', { replace: true });
          }
        } else {
          toast.message('Expiró su tiempo de sesión', {
            description: 'Por favor vuelva a ingresar sus creedenciales',
          });
          navigate('/', { replace: true });
        }
      } else {
        navigate('/', { replace: true });
      }
    };

    checkSession();
  }, []);


  return (
    <ToastProvider>
      <Routes>
        <Route path='/' element={<Login/>}/>
        <Route path='SelectCompany' element={<SelectCompany/>}/>
        <Route path='main' element={<LayoutDashboard/>}>
          <Route index element={<Home />} />
          <Route path='EmitirComprobantes' element={<EmitirComprobantes/>}/>
          <Route path='VerComprobantes' element={<VerComprobantes/>}/>
          <Route path='Almacen' element={<Almacen/>}/>
          <Route path='Marca' element={<Marca/>}/>
          <Route path='AreaLocal' element={<AreaLocal/>}/>
          <Route path='Medida' element={<Medida/>}/>
          <Route path='TPagos' element={<TPagos/>}/>
          <Route path='Vehiculo' element={<Vehiculo/>}/>
          <Route path='CrearProducto' element={<CrearProducto/>}/>
          <Route path='VerProducto' element={<VerProducto/>}/>
          <Route path='Categorias' element={<Categoria/>}/>
          <Route path='NuevoCliente' element={<NuevoCliente/>}/>
          <Route path='VerCliente' element={<VerCliente/>}/>
          <Route path='EmitirCotizacion' element={<EmitirCotizacion/>}/>
          <Route path='VerCotizacion' element={<VerCotizacion/>}/>
          <Route path='EmitirOC' element={<EmitirOC/>}/>
          <Route path='VerOC' element={<VerOC/>}/>
          <Route path='NuevaES' element={<NuevaES/>}/>
          <Route path='VerES' element={<VerES/>}/>
          <Route path='SettingsEmpresa' element={<SettingsEmpresa/>}/>
          <Route path='SettingsUsuario' element={<SettingsUsuario/>}/>
          <Route path='series' element={<Series/>}/>
          <Route path='Conductores' element={<Conductores/>}/>
          <Route path='reports' element={<Reports/>}/>

          {/*COMPONENTES FUERA DE LOS NODOS*/}
          <Route path='viewsale' element={<ViewSale/>}/>
          <Route path='editprice' element={<EditPrice/>}/>
          <Route path='editbuy' element={<EditBuy/>}/>
          <Route path='editinventory' element={<EditInventary/>}/>
          <Route path='newnote' element={<NewNote/>}/>
          <Route path='signalgpt' element={<SignalGPT/>}/>
          <Route path='importclientes' element={<ImportClientes/>}/>
          <Route path='importproductos' element={<ImportProductos/>}/>
        </Route>
      </Routes>
    </ToastProvider>
  )
}

